import React from 'react';
import PlayerStatsTable from '../components/PlayerStatsTable';
import PlayerHero from '../components/PlayerHero';
import { getPlayerInformation, getPlayerStats } from '../utils/player';

function Player() {
  if (!window.pageData?.data) {
    return null;
  }

  const { data } = window.pageData;

  const playerInformation = getPlayerInformation(data);
  const playerStats = getPlayerStats(data?.stats);

  return (
    <>
      <section className="site-container site-container--hug-on-mobile">
        {playerInformation && (
          <PlayerHero playerInformation={playerInformation} />
        )}
      </section>
      <section className="site-container">
        <div className="row">
          <div className="col-12">
            {playerStats && (
              <PlayerStatsTable playerStats={playerStats || []} />
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Player;
